import { render } from "./Product.vue?vue&type=template&id=3e384bfd&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=3e384bfd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e384bfd"

export default script